import api from "./api"

export function getCurrentEmployee(data) {
  return api.post('/tars/user/currentemployeedetail', JSON.stringify(data))
}

export function getUserConfig(data) {
  return api.post('/tars/user/userconfig', JSON.stringify(data))
}

export function getUserFactories(data) {
  const { userId } = data;
  return api.get(
    `/tva/v1/user/user-factories?user_id=${userId}`
  );
}
